import { NEW_SUCCEEDED, SEND_SUCCEEDED } from '../redux/event';

import {
  LOG_OUT_REQUESTED,
  RESET_PASSWORD_SUCCEEDED,
  SIGN_UP_SUCCEEDED,
  LOG_IN_SUCCEEDED,
} from '../redux/account';

import {
  CARD_FILTER_MODAL_OPENED,
  CARD_FILTER_MODAL_CLOSED,
  FLYER_FILTER_MODAL_OPENED,
  FLYER_FILTER_MODAL_CLOSED,
} from '../redux/modals';

import { DEEP_LINK_CLICKED } from '../redux/deepLinks';

import { EMAIL_DESIGN_REQUESTED } from '../redux/emailDesign';

import {
  EXPERIMENTS_SUCCEEDED,
  EXPERIMENTS_REQUEST_FAILED,
} from '../redux/experiments';

import { ADD_FAVORITE_SUCCESS } from '../redux/favorites';

import {
  LINK_CLICKED,
  ELEMENT_CLICKED,
  ONBOARDING_CHANGED,
} from '../redux/tracking';

import { GDPR_ACCEPTED, GDPR_DECLINED } from '../redux/gdpr';

// import { SIGN_UP_MODAL_OPENED } from '../redux/modals';

import { SAVE_AND_NAVIGATE_TO_DELIVERY_SUCCEEDED } from '../redux/viewport';

// import { ADD_FAVORITE_SUCCESS } from '../redux/favorites';

import {
  pbr_modal_opened,
  pbr_modal_closed,
} from '../tracking/modals.tracking';

import {
  pbr_select_sort,
  pbr_toggle_filter,
  pbr_toggle_filter_flyers,
} from '../tracking/filters.tracking';

import { NAV_FINISHED } from '../redux/nav';

import { SINGLE_CARD_FETCH_SUCCEEDED } from '../redux/singleCard';

import { SEARCH_REQUESTED, SEARCH_COMPLETED } from '../redux/search';

import { TRAY_OPENED, TRAY_CLOSED } from '../redux/tray';

// Likely need to format this for data to consume
import { WINDOW_AVAILABLE } from '../redux/app';
import { ROUTER_LOCATION_CHANGED } from '../redux/route';

// import {
//   NewEventSucceeded,
//   EventSendSucceeded,
//   EventCreated
// } from '../types/event';

// import {
//   SignUpRequest,
//   SignUpSucceeded,
//   LoginSucceeded
// } from '../types/account';

// import { SignUpModalOpened } from '../types/modals';

// import { SaveAndNavigateToDeliverySucceeded } from '../types/viewport';

// import {
//   AddFavoriteSuccess,
//   NavFinished,
//   LinkClickedAction,
//   ElementClickedAction,
//   SearchRequested,
//   LocationChangedAction,
//   PositionalTrackingProperties
// } from '../types';

const whitelistedEvents = [
  // redux/gdpr
  GDPR_ACCEPTED,
  GDPR_DECLINED,
  // redux/event
  NEW_SUCCEEDED,
  SEND_SUCCEEDED,
  // redux/account
  // SIGN_UP_REQUESTED,
  SIGN_UP_SUCCEEDED,
  LOG_IN_SUCCEEDED,
  // redux/modals
  // SIGN_UP_MODAL_OPENED,
  // redux/viewport
  SAVE_AND_NAVIGATE_TO_DELIVERY_SUCCEEDED,
  // redux/favorites
  // ADD_FAVORITE_SUCCESS,
  // redux/nav
  ADD_FAVORITE_SUCCESS,
  LOG_OUT_REQUESTED,
  RESET_PASSWORD_SUCCEEDED,
  DEEP_LINK_CLICKED,
  EMAIL_DESIGN_REQUESTED,
  EXPERIMENTS_SUCCEEDED,
  EXPERIMENTS_REQUEST_FAILED,
  ONBOARDING_CHANGED,
  NAV_FINISHED,
  CARD_FILTER_MODAL_OPENED,
  CARD_FILTER_MODAL_CLOSED,
  FLYER_FILTER_MODAL_OPENED,
  FLYER_FILTER_MODAL_CLOSED,
  pbr_select_sort,
  pbr_toggle_filter,
  pbr_toggle_filter_flyers,
  SINGLE_CARD_FETCH_SUCCEEDED,
  // NAV_FINISHED,
  pbr_modal_opened,
  pbr_modal_closed,
  // redux/tracking
  LINK_CLICKED,
  ELEMENT_CLICKED,

  // redux/search
  SEARCH_REQUESTED,
  SEARCH_COMPLETED,
  // redux/tray
  TRAY_OPENED,
  TRAY_CLOSED,

  // PAGE LOAD
  WINDOW_AVAILABLE,

  // nextjs router
  ROUTER_LOCATION_CHANGED,
];

export default whitelistedEvents;

// Exported for use by other consumers (i.e. data team). Fill this in once we're done.
// export const eventStructure = [
//   {
//     actionType: NEW_SUCCEEDED,
//     eventType: NewEventSucceeded
//   },
//   {
//     actionType: NEW_SUCCEEDED,
//     eventType: EventSendSucceeded
//   },
//   {
//     actionType: EVENT_CREATED,
//     eventType: EventCreated
//   },

//   {
//     actionType: SIGN_UP_REQUESTED,
//     eventType: SignUpRequest
//   },
//   {
//     actionType: SIGN_UP_SUCCEEDED,
//     eventType: SignUpSucceeded
//   },
//   {
//     actionType: LOG_IN_SUCCEEDED,
//     eventType: LoginSucceeded
//   },

//   {
//     actionType: SIGN_UP_MODAL_OPENED,
//     eventType: SignUpModalOpened
//   },

//   {
//     actionType: SAVE_AND_NAVIGATE_TO_DELIVERY_SUCCEEDED,
//     eventType: SaveAndNavigateToDeliverySucceeded
//   },

//   {
//     actionType: ADD_FAVORITE_SUCCESS,
//     eventType: AddFavoriteSuccess
//   },

//   {
//     actionType: NAV_FINISHED,
//     eventType: NavFinished
//   },

//   {
//     actionType: LINK_CLICKED,
//     eventType: LinkClickedAction
//   },
//   {
//     actionType: ELEMENT_CLICKED,
//     eventType: ElementClickedAction
//   },

//   {
//     actionType: SEARCH_REQUESTED,
//     eventType: SearchRequested
//   },

//   {
//     actionType: LOCATION_CHANGED,
//     eventType: LocationChangedAction
//   }
// ];

// export const positionalTrackingProperties = PositionalTrackingProperties;
